export default Object.freeze({
  CATEGORY_ICON: '카테고리 아이콘',
  CATEGORY_NO: '카테고리 번호',
  CATEGORY_NAME: '카테고리명',
  DISPLAYORDER: '카테고리 노출순서',
  ABLE: '카테고리 노출여부',
  CONTENT: '카테고리 이미지',
  FULLNAME: '전체 카테고리명',
  MALL: '몰 번호',

  INPUT_NAME: '카테고리 저장시 번호가 할당 됩니다.',
  INPUT_NO: '카테고리 저장시 번호가 할당 됩니다.',
  INPUT_URL: '카테고리 저장시 URL이 변경 됩니다.',

  TITLE: '전시카테고리 관리',
  MALLNAME1: '샘플몰',
  MALLNAME2: '카테고리 관리',
  EXALDOWN: '엑셀 다운로드',
  EXCEL_UPLOAD: '엑셀 일괄등록',
  ADD_BTN: '카테고리 추가',
  REMOVE_BTN: '삭제',
  DEFAULT_TREE_TEXT: '카테고리를 먼저 생성해주세요',
  CONFIG_INFO: '좌측에서 카테고리를 생성하시면, 카테고리 별 상세 설정이 가능합니다.',
  TAB_MENU1: '전시카테고리 설정',
  TAB_MENU2: '전시카테고리 상품관리',
  DISPLAY_CATEGORYNO: '카테고리 번호',
  DISPLAY_CATEGORYURL: '카테고리',
  DISPLAY_CATEGORYNAME: '카테고리명',
  DISPLAY_CATEGORY_CODE: '카테고리 코드',
  DISPLAY_CATEGORY_CODE_TOOLTIP: [
    '카테고리 번호 외에 카테고리를 구분할 수 있는 구분값으로 사용할 수 있습니다.',
    '쇼핑몰에서 카테고리 코드로 카테고리를 조회하거나 구분할 수 있습니다.'
  ],
  DISPLAY_YN: '전시여부',
  CATEGORY_ICONWRAP: '카테고리 아이콘',
  IMAGE_TEXT: '이미지',
  IMAGE_INFO: '권장',
  INPUTBOX_WRAP: '상단 콘텐츠',
  TOPSHOWYN1: '전시',
  TOPSHOWYN2: '전시 안함',
  TOPIMAGEUSEYN1: '등록',
  TOPIMAGEUSEYN2: '등록 안함',
  CONFIG_INFO1: '전시카테고리 설정은 최종적으로 [변경사항 저장] 버튼을 클릭 후 반영됩니다.',
  CONFIG_INFO2:
    '변경사항을 저장하지 않고 다른 메뉴로 이동 시 설정한 내용은 반영되지 않으니 반드시 저장하시길 바랍니다.',
  CONFIG_INFO3: '카테고리 번호, URL은 최종 저장 후에 생성됩니다.',
  CONFIG_INFO4: '카테고리 엑셀 일괄등록은 신규 등록만 가능하며, 카테고리 일괄 수정/삭제 기능은 제공하지 않습니다.',
  CONFIG_INFO5: '일괄등록 샘플 다운로드에 제공되는 가이드를 참고하여 입력 후 엑셀 일괄 등록하시길 바랍니다.',
  CONFIG_INFO6: '엑셀 다운로드 시 전체 카테고리를 다운로드 할 수 있습니다.',
  SAVEBTN: '변경사항 저장',
  DESCRIPTION1: '해당 전시카테고리에 상품을 등록(추가)/삭제하실 수 있습니다.',
  DESCRIPTION2:
    '상품조회 삭제 및 상품조회 등록 시에는 기존에 상품 삭제/등록 중인 내용을 반드시 저장하신 후에 사용하시기 바랍니다.',
  DESCRIPTION3:
    '상품 정보에 전시카테고리 변경은 상품 심사 항목 입니다. 삭제/등록 후 상품 심사 승인 후에 정상 노출됩니다.',
  DESCRIPTION4: '상품 등록 시 상품 심사 승인 전까지는 현재 전시카테고리에 상품이 조회되지 않습니다.',
  DESCRIPTION5: '※ 상품 정보에 전시카테고리 변경은 상품 심사 항목입니다.',
  DESCRIPTION6: '※ 상품 등록 시 상품 심사 승인 전까지는 현재 전시카테고리에 상품이 조회되지 않습니다.',
  SEARCH_PRODUCT_DELETE: '상품조회 삭제',
  REGISTER: '상품등록',
  IPTITLE1: '상품조회 등록',
  IPTITLE1_BTN: '상품조회',
  IPTITLE2: '상품번호 직접등록',
  IPTITLE2_PLACTHOLDER: '상품번호로 복수 상품 등록이 가능합니다. (Enter 또는 ","로 구분)',
  IPTITLE2_BTN: '상품추가',
  IPTITLE3: '상품번호 일괄등록',
  EXCELDOWN: '엑셀양식 다운로드',
  ADDEXCEL: '엑셀 일괄등록',
  TABLE_TIT: '등록 상품 총',
  NUM: '개',
  SELECTED_REMOVE: '선택상품 삭제',
  PAGESIZE: '개 보기',
  SAVE: '저장',

  CONFIRM_DELETE_GROUP_TEMPLATE: '해당 폴더에는 템플릿이 포함되어 있습니다. 삭제하시겠습니까?',
  CONFIRM_DELETE_GROUP: '폴더를 삭제하시겠습니까?',
  CONFIRM_DELETE_TEMPLATE: '템플릿을 삭제하시겠습니까?',
  TABLE_HEADER_ONE: '쇼핑몰',
  TABLE_HEADER_TWO: '상품번호',
  TABLE_HEADER_THREE: '상품관리코드',
  TABLE_HEADER_FOUR: '상품명',
  TABLE_HEADER_FIVE: '브랜드',
  TABLE_HEADER_SIX: '파트너사',
  TABLE_HEADER_SEVEN: '승인상태',
  TABLE_HEADER_EIGHT: '판매상태',
  TABLE_HEADER_EIGHT2: '판매설정',
  TABLE_HEADER_NINE: '삭제',
  CATEGORY_DEPTH1: '1depth',
  CATEGORY_DEPTH2: '2depth',
  CATEGORY_DEPTH3: '3depth',
  CATEGORY_DEPTH4: '4depth',
  CATEGORY_DEPTH5: '5depth',
  PREV: '이전',
  NEXT: '다음',
  DISPLAY_STATUS: '전시상태',
  PLEASE_SELECT: '상품을 선택해주세요.',
  SURE_DELETE: '선택한 상품을 전시카테고리에서 삭제하시겠습니까?\n하단 저장버튼을 통해 최종 삭제됩니다.',
  SURE1: '해당 상품(',
  SURE2: ')을 전시카테고리에서 삭제하시겠습니까?\n하단 저장버튼을 통해 최종 삭제됩니다.',
  NO_REGISTER: '등록가능한 상품이 없습니다.',
  DELETE_OVER_THEN: '개 상품이 삭제되었습니다. 하단 저장버튼을 통해 최종으로 저장됩니다.',
  ONLY_IMAGE: '이미지파일(Jpg,jpge,gif,png,bmp)만 등록해주세요.',
  MAX_512: '최대512kb개까지 등록가능합니다.',
  SAVE_OVER: '저장완료',
  NO_CHANGE: '변경된 상품이 없습니다.',
  SAVE_OVER_2: '저장되었습니다.',
  ALL: '승인상태',
  REGISTRATION_READY: '등록대기',
  APPROVAL_READY: '승인대기',
  APPROVAL_REJECTION: '승인거부',
  SALE_AGREEMENT_READY: '판매합의대기',
  SALE_AGREEMENT_REJECTION: '판매합의거부',
  FINISHED: '승인완료',
  AFTER_APPROVAL_READY: '수정 후 승인대기',
  AFTER_APPROVAL_REJECTION: '수정 후 승인거부',
  WAITING_SALE: '판매대기',
  ON_SALE: '판매중',
  END_SALE: '판매종료',
  WAITING_PRE_SALE: '예약판매대기',
  ON_PRE_SALE: '예약판매중',
  STOP_SELLING: '판매중지',
  PROHIBITION_SALE: '판매금지',
  AVAILABLE_FOR_SALE: '판매가능',
  DISABLE_COUNT:
    '입력하신 상품 {0}개 중 등록 불가능한 상품이 {1}개 ({2}) 있습니다.\n해당 상품을 제외하고 저장하시겠습니까?',
  SAVE_BUTTON_FINAL: '{0}개 상품이 등록되었습니다. 하단 변경사항 저장버튼을 통해 최종으로 저장됩니다.',
  REGISTER_RESULT: '등록결과',
  SUCCESS: '성공',
  FAIL: '실패',
  IN_INPUT_FAIL:
    '입력하신 상품 {0}개 중 등록 불가능한 상품이 {1}개 ({2}{3}{4}) 있습니다.\n해당 상품을 제외하고 저장하시겠습니까?',
});
